<template>
 <div class="warpper">
    <swiper :options="swiperOption">
      <swiper-slide v-for="item in swiperList" :key="item.id">
        <img class="swiper-img" :src="item.sytpurl" @click="getArticle(item.id,'新闻动态')" />
         <p class="title">{{item.title}}</p>
      </swiper-slide>
      <!-- 用于分页 -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>

  import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'lunbo',
  components: {
    swiper,
    swiperSlide
  },
 data () {
     return {
       swiperOption: {
         // 参数选项,显示小点
         pagination: '.swiper-pagination',
         // 循环轮播
         loop: true,
         // 每张播放时长1秒，自动播放
         autoplay: 9000,
         // 滑动速度
         speed: 500
       },
       swiperList: [
         {
           id: '',
           sytpurl:'',
           title:''
         }
       ]
     }
   },
   mounted() {
     this.findXinWendongtaiLunbotuList()
   },
  methods: {
    getArticle(articleId,menutext){
      let {
        href
      } = this.$router.resolve({
        path: "/Article", // 这里写的是要跳转的路由地址
        query: {
          articleId: articleId,
          menutext:menutext
        } // 这里写的是页面参数
      });
      window.open(href, '_blank');

    },
    findXinWendongtaiLunbotuList(){
      var that = this;
      		that.$myHttp.post("findXinWendongtaiLunbotuList")
      		  .then(function(data) {
              console.log(data)
      		    if (data.status == "200") {
                  that.swiperList = data.data.list;
      		    }  else {
      		      alert("数据请求错误")
      		    }

      		  }).catch(function(error) {
      		    alert(error)
      		  })

    }

  }
};
</script>

<style scoped>
.warpper >>> .swiper-pagination-bullet-active {
  background-color: #fff !important;
}
.warpper {
  overflow: hidden;
  width: 100%;
  height: 100%;

  background: #eee;

}
 .swiper-img {
    width: 480px;
    height:300px;
    cursor: pointer;
  }
.title{
  position: absolute;
  bottom: 0;
  height:30px;
  width:100%;
  line-height:30px;
  background:#00000060;
  color:#fff;
  padding-left:10px;
  padding-right:100px;
}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
   text-align: right;
   bottom:4px;
  }
</style>



// WEBPACK FOOTER //
// src/views/front/components/lunbo.vue